import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'sancElectricity',
    type: 'text',
    label: 'Electricity (KW/Hour)',
  },
  {
    colSpan: 1,
    name: 'sancGas',
    type: 'text',
    label: 'Gas (Cubic Meters)',
  },
];

export const sanctionFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label),
  [fields[1].name]: yup.string().label(fields[1].label),
};

const SanctionLoan = (props) => {
  return (
    <FormSection sectionName="Sanction Loan" sectionColumn={2} formFields={fields} {...props} />
  );
};

export default SanctionLoan;
